import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useState } from 'react';

const useSetting = () => {
  const [editable, setEditable] = useState(true);
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerEditableListener((editable) => {
      setEditable(editable);
    });
  }, [editor]);

  return { editable };
};

export default useSetting;
